module.exports = __webpack_public_path__ + "static/media/heart43.e7033dea.svg";